import Skeleton from '@/common/components/skeleton/Skeleton';
import { PROFILE_SKELETONS } from './constants/mySoftiesGridSkeleton.constants';
import {
	CreateSoftieCardSkeleton,
	PersonCardSkeleton,
	PersonCardSkeletonFooter,
	PersonCardSkeletonShade,
} from './MySoftiesGridSkeleton.styles';

const MySoftiesGridSkeleton = () => (
	<>
		<CreateSoftieCardSkeleton aria-hidden="true">
			<Skeleton width="52px" height="52px" radius="50%" />
			<Skeleton width="72px" height="12px" radius="6px" />
		</CreateSoftieCardSkeleton>
		{PROFILE_SKELETONS.map((item, index) => (
			<PersonCardSkeleton key={index} aria-hidden="true">
				<Skeleton width="100%" height="100%" radius="0" />
				<PersonCardSkeletonShade />
				<PersonCardSkeletonFooter>
					<Skeleton width={item.nameWidth} height="14px" radius="6px" />
					<Skeleton width={item.bioWidth} height="12px" radius="6px" />
				</PersonCardSkeletonFooter>
			</PersonCardSkeleton>
		))}
	</>
);

export default MySoftiesGridSkeleton;
